import { ILoginResponse } from "auth/auth.actions";
import { actionCreatorAuth } from "auth/auth.reducer";
import { loginUrl } from "common/infrastructure/endpoints";
import { RootStateOrAny } from "react-redux";
import { Action, Dispatch, Middleware } from "redux";
import { IApplicationState } from "./root-reducer";

const shouldRefresh = (state: IApplicationState) => {
    const expiration: number = state.auth.currentUser!.expiration;
    const timeNow = Math.floor(Date.now() / 1000);
    const margin = 600;

    return !(timeNow < expiration - margin);
}

let isRefreshing = false;

export const refreshTokenMiddleware: Middleware<{}, IApplicationState> = store => next => async (action: Action) => {
    const state = store.getState();
    
    if (state.auth.currentUser && shouldRefresh(state) && !isRefreshing) {
        isRefreshing = true;
        let refreshTokenFetch = await fetch(loginUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: `grant_type=refresh_token&refresh_token=${encodeURIComponent(state.auth.currentUser.refresh_token)}`
        })
        if (!refreshTokenFetch.ok) {
            isRefreshing = false;
            store.dispatch(actionCreatorAuth.logout);
            return await next(action);
        }
        const loginResponseData: ILoginResponse = await refreshTokenFetch.json();
        store.dispatch(actionCreatorAuth.refreshToken(loginResponseData));
        isRefreshing = false;
    }
    
    return await next(action);
}